import React from 'react'
import { Play } from 'lucide-react'

type Post = {
  post_id?: string
  link: string
  image?: string
  thumbnail?: string
  stat?: { plays?: number; views?: number }
}

const compact = (n: number) =>
  new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n)

/**
 * Posts a manager picked for one brand on a talent sheet, shown at the top of the athlete's
 * Content Shop: "Picked for Nike". A wrapping grid, never a sideways scroller.
 */
export const PickedPosts: React.FC<{ brandName?: string | null; posts: Post[] }> = ({
  brandName,
  posts,
}) =>
  posts.length ? (
    <div className="mb-4 rounded-2xl border border-[#D9F99D] bg-[#F7FEE7] p-3">
      <p className="mb-2 text-sm font-semibold text-[#111827]">
        Picked for {brandName || 'you'}{' '}
        <span className="font-normal text-[#6B7280]">by their manager</span>
      </p>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-6">
        {posts.slice(0, 6).map((p, i) => {
          const views = Number(p.stat?.plays ?? p.stat?.views ?? 0)
          const src = p.thumbnail || p.image
          return (
            <a
              key={p.post_id ?? p.link ?? i}
              href={p.link}
              target="_blank"
              rel="noreferrer"
              className="relative block aspect-[4/5] overflow-hidden rounded-xl bg-[#111827]"
            >
              {src ? (
                <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" />
              ) : null}
              {views ? (
                <span className="absolute bottom-1.5 left-1.5 inline-flex items-center gap-0.5 rounded bg-[rgba(0,0,0,0.6)] px-1 text-[11px] font-semibold text-[#FFFFFF]">
                  <Play className="h-2.5 w-2.5 fill-[#FFFFFF]" /> {compact(views)}
                </span>
              ) : null}
            </a>
          )
        })}
      </div>
    </div>
  ) : null

export default PickedPosts
